export const ENDPOINTS = {
  searchTemplates: () => `/library/template`,
  deleteTemplate: (id) => `/templates/${id}`
};
